import { SignedDocumentStatus } from "@wingspanhq/signed-documents/dist/lib/interfaces/signedDocument";
import { WSPosterProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementPendingApproval } from "../selectors/selectorIsRequirementPendingApproval";
import { RequirementCardContent } from "../components/RequirementCardContent";
import { selectorIsRequirementRejected } from "../selectors/selectorIsRequirementRejected";
import { SharedFileRequestStatus } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { BackgroundCheckRequestStatus } from "@wingspanhq/background-checks/dist/lib/interfaces";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces/identityVerificationRequest";
import { selectorIsRequirementApproved } from "../selectors/selectorIsRequirementApproved";

export const mapStatusesToCardDetails = <
  Status extends
    | SignedDocumentStatus
    | SharedFileRequestStatus
    | BackgroundCheckRequestStatus
    | IdentityVerificationRequestStatus
>(props: {
  requirement: IRequirementResponse;
  documentStatus: Status;
  documentStatuses: Record<Status, WSPosterProps>;
  pendingApprovalStatus: Status extends
    | SignedDocumentStatus
    | SharedFileRequestStatus
    | IdentityVerificationRequestStatus
    ? WSPosterProps
    : null;
  rejectedStatus: Status extends
    | SignedDocumentStatus
    | SharedFileRequestStatus
    | IdentityVerificationRequestStatus
    ? WSPosterProps
    : null;
  approvedStatus: Status extends IdentityVerificationRequestStatus
    ? WSPosterProps
    : null;
  customContent?: React.ReactNode | null;
}): React.ReactNode => {
  const {
    requirement,
    documentStatus,
    pendingApprovalStatus,
    rejectedStatus,
    approvedStatus,
    documentStatuses,
    customContent
  } = props;

  if (customContent) {
    return customContent;
  }

  let posterProps: WSPosterProps | null;

  if (
    selectorIsRequirementPendingApproval(requirement) &&
    pendingApprovalStatus
  ) {
    posterProps = pendingApprovalStatus;
  } else if (selectorIsRequirementRejected(requirement) && rejectedStatus) {
    posterProps = rejectedStatus;
  } else if (selectorIsRequirementApproved(requirement) && approvedStatus) {
    posterProps = approvedStatus;
  } else {
    posterProps = documentStatuses[documentStatus];
  }

  if (!posterProps) {
    return null;
  }

  return (
    <RequirementCardContent
      type={posterProps.type}
      title={posterProps.title}
      description={posterProps.description}
    />
  );
};
